<template>
  <div class="flv">
    5555
    <div class="main_box_item" v-if="speed_list_view.length">
      <el-button class="stabFlv" @click="fan">返回</el-button>

      <div class="item" v-for="(item, id) in speed_list_view" :key="id">
        <div class="headerP">
          <p>领取样品：{{ item.time }}</p>
          <p>领样人：{{ item.title_des }}</p>
          <p>领用实验室：{{ item.title1_des }}</p>
        </div>
        <div class="myvideo" v-if="item.jump_url.length > 0">
                <el-carousel trigger="click" height="250px">
                  <el-carousel-item
                    v-for="(video, index) in item.jump_url"
                    :key="index"
                  >
                    <video
                      name="videoElement"
                      class="centeredVideo"
                      :id="'video' + id + index"
                      controls
                    ></video>
                  </el-carousel-item>
                </el-carousel>
              </div>
        <div
          v-else-if="item.jump_url.length == 0"
          style="width: 100%; line-height: 120px; text-align: center"
        >
          暂无视频
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// fiv
import flvjs from "flv.js/dist/flv.min.js";
import { httpScheduleSale } from "../../utils/myapplication";
export default {
  data() {
    return {
      speed_list_view: [],
    };
  },
  methods: {
    fan() {
      this.$router.back();
    },
    // 获取flv进度
    getSpeedFlv() {
      let data = {
        project_number: this.$route.query.project_number,
        type: 2,
      };
      httpScheduleSale(data)
        .then((res) => {
          console.log(res.data, "888+++++++++++++++++++++res.Flv");
          this.speed_list_view = res.data.data;
          this.$nextTick(() => {
            this.pullStreamFlv();
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    pullStreamFlv() {
      this.speed_list_view.forEach((i, k) => {
        i.jump_url.forEach((item, index) => {
          // 判断浏览器支不支持播放
          if (flvjs.isSupported()) {
            // 获取video的id
            let videoElement = document.getElementById("video" + k + index);
            console.log("videoElement", videoElement);

            // 创建一个播放器实例
            this.flvPlayer = flvjs.createPlayer(
              {
                type: "flv", //媒体类型
                isLive: true, //是不是直播流
                duration: 0,
                url: item, //流地址
              },
              {
                enableWorker: true, //不启用分离线程
                enableStashBuffer: false, //是否启用缓存区
                stashInitialSize: 128,
                lazyLoad: false,
                lazyLoadMaxDuration: 0,
                lazyLoadRecoverDuration: 0,
                deferLoadAfterSourceOpen: false,
                fixAudioTimestampGap: false, //为flase 才会音视频同步
                // autoCleanupSourceBuffer: true, //自动清除缓存
                // autoCleanupMinBackwardDuration: 60, //自动清除时间间隔
              }
            );
            console.log(this.flvPlayer, "flvPlayer");

            //将播放实例注册到节点
            this.flvPlayer.attachMediaElement(videoElement);
            this.flvPlayer.load(); //加载数据流
            this.flvPlayer.play(); //播放数据流
            //避免时间长时间积累缓冲导致延迟越来越高
            setInterval(() => {
              if (!videoElement.buffered.length) {
                return;
              }
              let end = this.flvPlayer.buffered.end(0);
              let currentTime = videoElement.currentTime;
              let diff = end - currentTime;
              if (diff >= 1) {
                videoElement.currentTime = parseFloat(end);
                console.log("进行时延校正" + videoElement.currentTime);
              }
            }, 3 * 1000);
          }
        });
      });
    },
    // 销毁视频流
    destoryVideo() {
      if (this.flvPlayer != null) {
        this.flvPlayer.pause(); //暂停播放数据流
        this.flvPlayer.unload(); //取消数据流加载
        this.flvPlayer.detachMediaElement(); //将播放实例从节点拿出
        this.flvPlayer.destroy(); //销毁播放实例
        this.flvPlayer = null; //置空
      }
    },
  },
  created() {
    this.getSpeedFlv();
  },
};
</script>

<style scoped lang="scss">
.flv {
  width: 100vw;
  height: 100vh;
  background-color: #03246b;

  .main_box_item {
    display: flex;
    flex-wrap: wrap;
    // justify-content: flex-start;
    // align-items: center;
    color: aliceblue;

    position: relative;

    .stabFlv {
      position: absolute;
      float: right;
    }

    .item {
      width: 50%;
      height: 400px;

      .headerP {
        width: 650px;
        display: flex;
        justify-content: space-around;
        padding: 50px 0 0 0;
      }

      .myvideo {
        width: 600px;
        height: 300px;
        padding: 0 0 0 80px;

        video {
          width: 480px;
          height: 240px;
        }
      }
    }
  }
}
</style>